import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between py-1" }
const _hoisted_2 = { class: "text-body-2 text-grey-darken-1" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementSummaryRow',
  props: {
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.label), 1),
      _renderSlot(_ctx.$slots, "badge")
    ]),
    _renderSlot(_ctx.$slots, "value")
  ]))
}
}

})